<h1 mat-dialog-title class="title">{{"DIALOG_CONFIRM.DEL" | translate}}</h1>
<div mat-dialog-content>
  {{"DIALOG_CONFIRM.SURE" | translate}}
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="close()">{{"DIALOG_CONFIRM.NO" | translate}}</button>
  <button mat-button cdkFocusInitial (click)="delete()">{{"DIALOG_CONFIRM.OK" | translate}}</button>
</div>
